var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 17.75C8.625 18.5125 8.9279 19.2438 9.46707 19.7829C10.0062 20.3221 10.7375 20.625 11.5 20.625C12.2625 20.625 12.9938 20.3221 13.5329 19.7829C14.0721 19.2438 14.375 18.5125 14.375 17.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 2.65625C17.9192 3.54186 19.0449 4.78267 19.7917 6.25",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20831 6.25C3.95507 4.78267 5.0808 3.54186 6.46874 2.65625",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.03102 10.5625C5.03102 8.84688 5.71254 7.20153 6.92567 5.9884C8.13879 4.77528 9.78415 4.09375 11.4998 4.09375C13.2154 4.09375 14.8607 4.77528 16.0739 5.9884C17.287 7.20153 17.9685 8.84688 17.9685 10.5625C17.9685 13.7807 18.7142 15.6477 19.3072 16.6719C19.3702 16.781 19.4034 16.9047 19.4035 17.0306C19.4036 17.1566 19.3706 17.2803 19.3078 17.3895C19.245 17.4987 19.1547 17.5895 19.0458 17.6528C18.9368 17.716 18.8132 17.7496 18.6873 17.75H4.31227C4.18647 17.7492 4.06307 17.7155 3.95441 17.6521C3.84574 17.5887 3.75562 17.4979 3.69305 17.3888C3.63048 17.2796 3.59765 17.156 3.59784 17.0302C3.59803 16.9044 3.63124 16.7808 3.69414 16.6719C4.28621 15.6477 5.03102 13.7798 5.03102 10.5625Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.1d0f4d555a063c2f7f1b4817be861c4a.svg";
export { ForwardRef as ReactComponent };